<template>
    <div class="main-content">
        <div class="page-header">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link slot="item-title" :to="'/admin/sites/'+this.site">Vezérlőpult</router-link></li>
                <li class="breadcrumb-item active">Képváltók</li>
            </ol>
            <h1 class="d-inline mr-3">Képváltók</h1>
            <button class="btn btn-outline-info btn-sm align-text-bottom">
                <router-link to="/admin/carousels/create">
                    <i class="icon-fa icon-fa-plus"/> Új hozzáadása
                </router-link>
            </button>
        </div>
        <div class="card">
            <div class="card-body">
                <cool-table :fields="fields"
                    :data-source="dataSource"
                    :textfilter="true">
                    <template slot="name" slot-scope="props">
                        <router-link :to="`/admin/carousels/${props.rowData.id}/edit`">
                            {{ props.rowData.name }}
                        </router-link>
                    </template>
                </cool-table>
            </div>
        </div>
    </div>
</template>

<script>
import ls from '../../services/ls.js'
import CoolTable from '../../components/CoolTable'

export default {
    components: {
        CoolTable
    },
    data () {
        return {
            site: null,
            fields: [
                {
                    name: 'id',
                    title: 'Azonosító'
                },
                {
                    name: 'name',
                    title: 'Név',
                },
            ]
        }
    },
    methods: {
        dataSource (sortOrder, pagination, filters) {
            var sort = {
                field: sortOrder[0] ? sortOrder[0].sortField : 'title',
                direction: sortOrder[0] ? sortOrder[0].direction : 'asc',
            };

            return axios.get('/api/admin/carousels', {
                params: {
                    with: 'imageCount',
                    page: pagination.current_page,
                    filters: {
                        site: this.site,
                        ...filters,
                    },
                    sort: sort.field,
                    order: sort.direction
                }
            })
        }
    },
    created() {
        this.site = ls.get('site')
    }
}
</script>

<style>

</style>
